import React, { useEffect, useState } from "react";
import CardHeader from "../../components/common/CardHeader";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import CardBody from "../../components/common/CardBody";

import toast from "react-hot-toast";
import Progress from "react-progress-2";
import "react-progress-2/main.css";
import ProjectListBox from "../../components/backend/ProjectListBox";
import { privateApi } from "../../api";

const ProjectList = () => {
      const [loading, setLoading] = useState(false);
      const [projects, setProjects] = useState([]);
      const [totalProjects, setTotalProjects] = useState(0);
      const [perPages, setPerPages] = useState(0);
      const [currentPage, setCurrentPage] = useState(0);

      const [limit, setLimit] = useState(10);
      const [search, setSearch] = useState("");

      const loadData = async () => {
            setLoading(true);
            await privateApi
                  .get(`/dashboard/projects?limit=${limit}&search=${search}`)
                  .then((response) => {
                        setProjects(response.data.projects);
                        setTotalProjects(response.data.totalProjects);
                        setPerPages(response.data.itemsCountPerPage);
                        setCurrentPage(response.data.currentPage);
                        setLoading(false);
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      };
      useEffect(() => {
            loadData();
      }, [limit, search]);

      async function getData(pageNumber = 1) {
            window.scrollTo(0, 0);
            setLoading(true);
            Progress.show();
            const url = `/dashboard/projects?page=${pageNumber}&limit=${limit}&search=${search}`;
            await privateApi(url)
                  .then((response) => {
                        setProjects([]);
                        setProjects(response.data.projects);
                        setTotalProjects(response.data.totalProjects);
                        setPerPages(response.data.itemsCountPerPage);
                        setCurrentPage(response.data.currentPage);
                        Progress.hide();
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      }

      return (
            <>
                  <Row>
                        <Col lg={12}>
                              <Card>
                                    <CardHeader title="Project List">
                                          <div className="d-flex">
                                                <Link
                                                      to="/dashboard/projects/create"
                                                      className="btn btn-link me-2"
                                                >
                                                      Add New
                                                </Link>
                                          </div>
                                    </CardHeader>
                                    <CardBody
                                          setLimit={setLimit}
                                          setSearch={setSearch}
                                          totalItems={totalProjects}
                                          getData={getData}
                                          currentPage={currentPage}
                                          perPages={perPages}
                                    >
                                          <ProjectListBox
                                                loading={loading}
                                                setLoading={setLoading}
                                                projects={projects}
                                                loadData={loadData}
                                                setProjects={setProjects}
                                          />
                                    </CardBody>
                              </Card>
                        </Col>
                  </Row>
            </>
      );
};

export default ProjectList;
